import React from "react";
import env from "../../../../env/env.json";
import Checkbox from "../../../UI/Checkbox";
import Divider from "../../../UI/Divider";
import RadioGroup from "../../../UI/RadioGroup";
import RadioMulti from "../../../UI/RadioMulti";
import DescriptionProjet from "../DescriptionProjet";
import FormRenouvellement from "../FormRenouvellement";

const LocationMeublee = ({
  formData,
  setFormData,
  handleChange,
  inputFocus,
  handleTrimValue,
  page,
  setValidResponse,
  urlAPI,
  ville,
}) => {
  const taxe_sejour = env.taxe_sejour;

  return (
    <>
      <div className="position-relative">
        <label htmlFor="ProNumEnregistrement" className="form-label fw-bold">
          Le cas échéant, veuillez indiquer le numéro d’enregistrement de cette
          location meublée courte durée (location touristique) figurant sur vos
          annonces de location.
        </label>
        <input
          className="form-control inputReg ProActivite-group getLabel"
          type="text"
          maxLength={15}
          name="ProNumEnregistrement"
          id="ProNumEnregistrement"
          value={formData.ProNumEnregistrement || ""}
          onChange={handleChange}
          onInput={inputFocus}
          onBlur={handleTrimValue}
          placeholder="N° d'enregistrement (ex: 12345-67, 123-456)"
        />
        <div className="invalid-tooltip">
          Veuillez entrer un numéro d'enregistrement valide
        </div>
      </div>
      <p className="background--warning p-4 mt-3">
        <i className="fas fa-info-circle"></i>&nbsp;Le numéro d'enregistrement
        est un numéro délivré par la mairie de votre ville lors de la
        déclaration de votre location saisonnière. Pour en savoir plus,&nbsp;
        <a href={taxe_sejour} target="_blank" rel="noreferrer">
          Cliquez ici.
        </a>
      </p>
      <Divider />
      <section>
        <RadioMulti
          label="Êtes-vous déjà bénéficiaire d'une demande de changement d'usage d'un local d'habitation ?"
          inputClassName="page-2-required ProActivite-group"
          name="ProPremierCU"
          value_1="Non, je souhaite obtenir ma première autorisation de changement d'usage"
          value_2="Oui, je souhaite obtenir la reconduction de ma première autorisation pour 2 ans supplémentaires"
          value_3="Oui, je souhaite obtenir une nouvelle autorisation au profit d'un autre bien"
          handleChange={handleChange}
          inputFocus={inputFocus}
          datagroup="ProPremierCU"
          checked_1={
            formData.ProPremierCU ===
            "Non, je souhaite obtenir ma première autorisation de changement d'usage"
          }
          checked_2={
            formData.ProPremierCU ===
            "Oui, je souhaite obtenir la reconduction de ma première autorisation pour 2 ans supplémentaires"
          }
          checked_3={
            formData.ProPremierCU ===
            "Oui, je souhaite obtenir une nouvelle autorisation au profit d'un autre bien"
          }
        />
        {formData.ProPremierCU ===
          "Oui, je souhaite obtenir la reconduction de ma première autorisation pour 2 ans supplémentaires" && (
          <FormRenouvellement
            formData={formData}
            setFormData={setFormData}
            setValidResponse={setValidResponse}
            handleTrimValue={handleTrimValue}
            urlAPI={urlAPI}
            ville={ville}
            page={page}
          />
        )}
      </section>
      <Divider />
      <RadioGroup
        label="Le bien est-il détenu en indivision ou démembré avec une personne ayant déjà bénéficié d'une autorisation de changement d'usage&nbsp;?"
        inputClassName={"page-2-required ProActivite-group ProPremierCU-group"}
        name="ProAutoCU"
        handleChange={handleChange}
        inputFocus={inputFocus}
        value_1="Oui"
        value_2="Non"
        checked_1={formData?.ProAutoCU === "Oui"}
        checked_2={formData?.ProAutoCU === "Non"}
        datagroup="ProAutoCU"
      />
      <Divider />
      <DescriptionProjet
        formData={formData}
        handleChange={handleChange}
        inputFocus={inputFocus}
        handleTrimValue={handleTrimValue}
        page={page}
      />
      <Divider />
      <div className="background--warning p-4">
        <p className="fw-bold">
          Veuillez accepter les conditions ci-dessous&nbsp;:&nbsp;
          <span className="text-danger">*</span>
        </p>
        <Checkbox
          checkClassName="page-2-required ProActivite-group"
          name="Check9"
          value="Je m'engage à rendre l'usage d'habitation au local à l'expiration du délai de validité de l'autorisation"
          inputFocus={inputFocus}
          handleChange={handleChange}
          checked={
            formData.Check9 ===
            "Je m'engage à rendre l'usage d'habitation au local à l'expiration du délai de validité de l'autorisation"
              ? true
              : false
          }
          label="Je m'engage à rendre l'usage d'habitation au local à l'expiration du délai de validité de l'autorisation."
        />
        <Checkbox
          checkClassName="page-2-required ProActivite-group"
          name="Check13"
          value="J'atteste sur l'honneur que le logement objet de la présente demande est un logement décent tel que défini par le décret n°2002-120 du 30 janvier 2002, qu'il n'appartient pas à un organisme d'habitation à loyer modéré, qu'il ne fait pas l'objet d'un conventionnement en application de l'article L.831-1 du Code de la Construction et de l'Habitation et de l'article R.321-23 du Code de la Construction et de l'Habitation et qu'il ne fait pas l'objet d'un arrêté d'insalubrité ou de péril."
          inputFocus={inputFocus}
          handleChange={handleChange}
          checked={
            formData.Check13 ===
            "J'atteste sur l'honneur que le logement objet de la présente demande est un logement décent tel que défini par le décret n°2002-120 du 30 janvier 2002, qu'il n'appartient pas à un organisme d'habitation à loyer modéré, qu'il ne fait pas l'objet d'un conventionnement en application de l'article L.831-1 du Code de la Construction et de l'Habitation et de l'article R.321-23 du Code de la Construction et de l'Habitation et qu'il ne fait pas l'objet d'un arrêté d'insalubrité ou de péril."
              ? true
              : false
          }
          label="J'atteste sur l'honneur que le logement objet de la présente demande est un logement décent tel que défini par le décret n°2002-120 du 30 janvier 2002, qu'il n'appartient pas à un organisme d'habitation à loyer modéré, qu'il ne fait pas l'objet d'un conventionnement en application de l'article
          L.831-1 du Code de la Construction et de l'Habitation et de l'article R.321-23 du Code de la Construction et de l'Habitation et qu'il ne fait pas l'objet d'un arrêté d'insalubrité ou de péril."
        />
        <Checkbox
          checkClassName="page-2-required ProActivite-group"
          name="Check17"
          value="J'atteste sur l'honneur que le logement objet de la présente demande n'a pas été acquis dans le cadre d'une accession à prix maitrisée, tant pour les biens construits par des promoteurs immobiliers que par la SPLM, ou que le bien a été acquis depuis plus de 10 ans."
          inputFocus={inputFocus}
          handleChange={handleChange}
          checked={
            formData.Check17 ===
            "J'atteste sur l'honneur que le logement objet de la présente demande n'a pas été acquis dans le cadre d'une accession à prix maitrisée, tant pour les biens construits par des promoteurs immobiliers que par la SPLM, ou que le bien a été acquis depuis plus de 10 ans."
              ? true
              : false
          }
          label="J'atteste sur l'honneur que le logement objet de la présente demande n'a pas été acquis dans le cadre d'une accession à prix maitrisée, tant pour les biens construits par des promoteurs immobiliers que par la SPLM, ou que le bien a été acquis depuis plus de 10 ans."
        />
      </div>
    </>
  );
};

export default LocationMeublee;
